import { render } from "./PurchasesView.vue?vue&type=template&id=60a293e2"
import script from "./PurchasesView.vue?vue&type=script&lang=js"
export * from "./PurchasesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__